/**
* prism.js default theme for JavaScript, CSS and HTML
* Based on dabblet (http://dabblet.com)
* @author Lea Verou
*/

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #000;
	--pce-bg: #f5f2f0;
	--pce-widget-border: #bfbfbf;
	--pce-widget-bg: #edeae8;
	--pce-widget-color: #444;
	--pce-widget-color-active: #000;
	--pce-widget-color-options: #666;
	--pce-widget-bg-input: #f5f2f0;
	--pce-widget-bg-hover: #b8b8b84f;
	--pce-widget-bg-active: #c2dff2;
	--pce-widget-focus: #0077f0;
	--pce-search-match: #ea5c0054;
	--pce-widget-bg-error: #f2dede;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #eae8e6;
	--pce-selection-match: #b6d5fc80;
	--pce-line-number: #9d897b;
	--pce-scrollbar: 24, 7%, 35%;
	--pce-bg-fold: #424242;
	--pce-guide-indent: #4b413a33;
	--pce-ac-icon-class: #d67e00;
	--pce-ac-icon-enum: #d67e00;
	--pce-ac-icon-event: #d67e00;
	--pce-ac-icon-function: #652d90;
	--pce-ac-icon-interface: #007acc;
	--pce-ac-icon-variable: #007acc;
	--pce-ac-match: #0066bf;
	--pce-tabstop: #0a326433;
	--pce-invisibles: #3333;
	--pce-selection: #b6d5fc;
	color-scheme: light;
}

.pce-match {
	--pce-search-match: #c7ada9;
}

.active-line {
	--pce-line-number: #4d3a2e;
}

.active-indent {
	--pce-guide-indent: #38322f66;
}

[class*="language-"] {
	color: #000;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: #708090;
}

.token.punctuation,
.token.attr-equals {
	color: #999;
}

.token.namespace {
	opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
	color: #905;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
	color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
	color: #9a6e3a;
}

.token.atrule,
.token.attr-value,
.token.keyword {
	color: #07a;
}

.token.function,
.token.class-name {
	color: #dd4a68;
}

.token.regex,
.language-regex,
.token.important,
.token.variable {
	color: #e90;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.italic {
	font-style: italic;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #0431fa;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #319331;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #7b3814;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #b9b9b9, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #57575740;
}
